export default "https://d1e6s5z4lzmgxx.cloudfront.net/1e48d3d4-9cd4-48c4-b169-1af184d58c4c/images/mezzoforte-icon.svg?baf7ed6b2a8c2e326ac2f66757fe3fa1";